<div
  class="avatar-container"
  [attr.data-size]="size"
  [attr.data-shape]="shape"
  [attr.data-variant]="variant"
  [attr.data-status]="displayStatus"
  [attr.data-disabled]="disabled"
  [attr.data-clickable]="clickable"
>
  <div
    class="avatar-wrapper"
    [attr.role]="clickable ? 'button' : null"
    [attr.tabindex]="clickable && !disabled ? 0 : -1"
    [attr.aria-label]="displayAlt"
    (click)="onAvatarClick()"
    (keydown.enter)="onAvatarClick()"
    (mouseenter)="onAvatarHover()"
  >
    <!-- Image Avatar -->
    <img
      *ngIf="hasImage"
      class="avatar-image"
      [src]="displaySrc"
      [alt]="displayAlt"
      (error)="onImageError()"
    />

    <!-- Initials Avatar -->
    <div *ngIf="showInitials && !hasImage" class="avatar-initials">
      {{ displayInitials }}
    </div>

    <!-- Icon Avatar -->
    <div *ngIf="showIcon && !hasImage && !showInitials" class="avatar-icon">
      <umss-icon name="phosphorUser" [size]="iconSize"></umss-icon>
    </div>

    <!-- Status Indicator -->
    <div
      *ngIf="displayStatus"
      class="avatar-status"
      [attr.data-status]="displayStatus"
    >
      <div class="status-dot"></div>
    </div>
  </div>
</div>
